var DEFAULT_BODY_COLOR = "base.color.text.body.primary";
var DEFAULT_BODY_SIZE = "medium";

export { DEFAULT_BODY_SIZE as D, DEFAULT_BODY_COLOR as a };
//# sourceMappingURL=shared3.js.map
